<template>
	<div class="workplace">
		<a-card :bordered="false" class="workplace-stat-card">
			
		</a-card>
	</div>
</template>

<script>
const MOCK_CURRENT = {
	totalUser: 12580,
	maleUser: 7820,
	femaleUser: 4760,
};

const MOCK_PERIOD = {
	yesterday: {
		total: 342,
		activeMale: 198,
		activeFemale: 144,
		registerMale: 12,
		registerFemale: 8,
	},
	last7: {
		total: 2156,
		activeMale: 1240,
		activeFemale: 916,
		registerMale: 45,
		registerFemale: 32,
	},
	month: {
		total: 8934,
		activeMale: 5200,
		activeFemale: 3734,
		registerMale: 128,
		registerFemale: 96,
	},
};

export default {
	data() {
		return {
			current: { ...MOCK_CURRENT },
			periodYesterday: { ...MOCK_PERIOD.yesterday },
			periodLast7: { ...MOCK_PERIOD.last7 },
			periodMonth: { ...MOCK_PERIOD.month },
		};
	},
	methods: {
		fmtNum(v) {
			if (v == null || v === '') return '0';
			return Number(v).toLocaleString();
		},
		formatDelta(n) {
			if (n > 0) return `+${n}`;
			return String(n);
		},
		deltaClass(n) {
			if (n > 0) return 'delta-up';
			if (n < 0) return 'delta-down';
			return '';
		},
	},
};
</script>

<style lang="less" scoped>
.workplace {
	padding: 8px 16px 0 16px;
}

.workplace-stat-card {
	margin-bottom: 8px;
}

.workplace-stat-card /deep/ .stat-card {
	box-shadow: none;
	border: 1px solid #f0f0f0;
	height: 100%;

	.ant-card-body {
		padding: 16px 18px;
		height: 100%;
		box-sizing: border-box;
	}
}

/deep/ .stat-card-inner {
	display: flex;
	height: 100%;
}

.stat-left {
	flex: 1;
	min-width: 0;
}

.stat-title {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.45);
	margin-bottom: 8px;
}

.stat-main {
	font-size: 28px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.88);
	line-height: 1.2;
}

.stat-divider {
	width: 1px;
	background: #f0f0f0;
	margin: 0 16px;
	flex-shrink: 0;
}

.stat-right {
	flex: 1;
	font-size: 13px;
	color: rgba(0, 0, 0, 0.65);
	line-height: 1.8;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.delta-up {
	color: #52c41a;
	margin-left: 4px;
	font-weight: 500;
}

.delta-down {
	color: #ff4d4f;
	margin-left: 4px;
	font-weight: 500;
}
</style>
